import { PAGE_SCREENSHOT_URL } from '@/env';

export type PageScreenshotType =
  | 'post'
  | 'stream'
  | 'stream-package'
  | 'ct'
  | 'ct-stats';

type PageScreenshotUrlArgs = {
  type: PageScreenshotType;
  id: string;
  version: string;
  w?: number;
  h?: number;
  routeSearchParams?: URLSearchParams | string;
};

const allowedRouteSearchParams = {
  post: [],
  stream: [],
  'stream-package': [],
  ct: ['theme', 'cs', 'card', 'node'],
  'ct-stats': ['card'],
} satisfies Record<PageScreenshotType, string[]>;

const hashString = (value: string) => {
  let hash = 2166136261;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  return (hash >>> 0).toString(36);
};

const stringifyVersionPart = (part: unknown) => {
  if (typeof part === 'string') return part;
  try {
    return JSON.stringify(part);
  } catch {
    return String(part);
  }
};

export const getPageScreenshotVersion = (...parts: unknown[]) =>
  hashString(parts.map(stringifyVersionPart).join('|'));

export const getPageScreenshotUrl = ({
  type,
  id,
  version,
  w,
  h,
  routeSearchParams,
}: PageScreenshotUrlArgs) => {
  const screenshotParams = new URLSearchParams();
  screenshotParams.set('type', type);
  screenshotParams.set('id', id);
  screenshotParams.set('v', version);

  if (w) screenshotParams.set('w', String(w));
  if (h) screenshotParams.set('h', String(h));

  if (routeSearchParams) {
    const sourceParams = new URLSearchParams(routeSearchParams);
    for (const param of allowedRouteSearchParams[type]) {
      const value = sourceParams.get(param);
      if (value) screenshotParams.set(param, value);
    }
  }

  return PAGE_SCREENSHOT_URL + `?${screenshotParams.toString()}`;
};
